import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';


import {
  APP_INIT_ERROR, APP_READY, initialize, mergeConfig, subscribe,
} from '@edx/frontend-platform';
import { ErrorPage } from '@edx/frontend-platform/react';

import configuration from './config';
import messages from './i18n';
import MainApp from './MainApp';

// Default to Hebrew if no language preference cookie is set
const LANG_COOKIE = 'openedx-language-preference';
if (!document.cookie.split('; ').some(c => c.startsWith(`${LANG_COOKIE}=`))) {
  const rootDomain = window.location.hostname.split('.').slice(1).join('.');
  document.cookie = `${LANG_COOKIE}=he; path=/; domain=.${rootDomain}; max-age=31536000; SameSite=None; Secure`;
}

subscribe(APP_READY, () => {

  ReactDOM.render(
    <MainApp />,
    document.getElementById('root'),
  );
});

subscribe(APP_INIT_ERROR, (error) => {
  ReactDOM.render(<ErrorPage message={error.message} />, document.getElementById('root'));
});

initialize({
  handlers: {
    config: () => {
      mergeConfig(configuration);
    },
  },
  messages,
});
